import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="landing-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/images/logo.svg" alt="Neural Network Visualizer" className="footer-logo" />
            <p className="footer-copyright">
              © Neural Network Visualizer
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

